'use strict';

export default class Accordion {
  constructor() {
    if(!$('body').hasClass('sfPageEditor')) {
      var $accordion = $('.accordion');
      var $accordionItem = $('.accordion__item');
      var $accordionBody = $('.accordion__item__body');
      var $accordionHead = $('.accordion__item__head');

      if( $accordion.length ){
        $accordionBody.addClass("-hide");

        $accordionHead.on('click', function(){
          var $accordionItemBody = $(this).parents('.accordion__item').find('.accordion__item__body');
          $accordionItemBody.slideToggle(300);
          $(this).toggleClass('-reveal');
          if($(this).attr('aria-expanded') === "true") {
            $(this).attr('aria-expanded','false');
          } else {
            $(this).attr('aria-expanded','true');
          }
        })
      }
    }
  }
}
